// DS: UI06
import React from 'react';
import classnames from 'classnames';
import PlainButtonOrLink from '../Buttons/PlainButtonOrLink';
import s from './ToggleButton.scss';
var ToggleButton = function (_a) {
    var value = _a.value, onChange = _a.onChange, _b = _a.view, view = _b === void 0 ? 'ui06-b' : _b, biData = _a.biData, disabled = _a.disabled, ariaLabel = _a["aria-label"], ariaLabelledBy = _a["aria-labelledby"];
    var status = value ? 'on' : 'off';
    return (React.createElement(PlainButtonOrLink, { className: classnames(s['root'], s[view], s[status], disabled && s['disabled']), onClick: function () { return onChange(!value); }, biData: biData, disabled: disabled, "aria-pressed": value, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy },
        React.createElement("span", { className: s['dot'] }),
        React.createElement("span", { className: s['status-text'], "aria-hidden": "true" }, status)));
};
export default ToggleButton;
//# sourceMappingURL=ToggleButton.js.map